import { render, staticRenderFns } from "./EntityEditForm.vue?vue&type=template&id=3b453bb3"
import script from "./EntityEditForm.vue?vue&type=script&lang=js"
export * from "./EntityEditForm.vue?vue&type=script&lang=js"
import style0 from "./EntityEditForm.vue?vue&type=style&index=0&id=3b453bb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports